import React from "react";
import { useSelector } from "react-redux";
import App from "./App";
import { useAuth } from "./hooks/auth.hook";
import { useSessionData } from "./hooks/useSessionData";

const AppContainer = () => {
  const { login, logout, token, checkDone, sessionId } = useAuth();
  const session = useSelector((state) => state.authSession);
  const userType = useSelector((state) => state.user.type);
  const retrySessionData = useSessionData(sessionId);
  return (
    <App
      login={login}
      logout={logout}
      isAuthenticated={!!token}
      checkDone={checkDone}
      session={session}
      retrySessionData={retrySessionData}
      userType={userType}
    />
  );
};
export default AppContainer;
